export default __webpack_public_path__ + "static/media/Remax_Collections.2cf57eb1.jpg";